import { useTypingAnimation } from 'hooks'

import type { INicheDescription } from './niche-description.types'
import { NicheDescriptionView } from './niche-description.view'

export const NicheDescription = (props: INicheDescription) => {
  const descriptionText = useTypingAnimation(props.descriptionText, { autoStart: true })
  return <NicheDescriptionView {...props} descriptionText={descriptionText.animatedText} />
}
